import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Arvioitu {{orderMethod}}: {{day}} noin klo {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Tilaus hylätty',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Tilaus vastaanotettu',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Tilauksesi on nähty',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Tilaus vahvistettu',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Tilaus on valmis',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Tilaus on toimituksessa',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Tilaus on valmis',
    },
  },
  labels: {
    today: 'Tänään',
  },
  waiting_confirmation: {
    title: 'Odottaa tilauksen vahvistusta',
    description: 'Hetki vain...',
  },
  pickup_time: {
    title: 'Noutoaika',
    description: 'Vahvistanut {{name}}',
  },
  delivery_time: {
    title: 'Toimitusaika',
    description: 'Vahvistanut {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} muutti ajan ajasta {{initialTime}} aikaan {{currentTime}}',
  },
};
